import PropTypes from 'prop-types';
import cn from 'classnames';
import React, { PureComponent } from 'react';
import styles from './Card.module.scss';

export default class Card extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    icon: PropTypes.object,
    fixMinHeight: PropTypes.oneOf(['big', 'small']),
    alignCenter: PropTypes.bool,
    className: PropTypes.string,
    hoverDisabled: PropTypes.bool,
  };

  static defaultProps = {
    alignCenter: false,
    fixMinHeight: null,
    className: '',
  };

  render() {
    const {
      children,
      icon: Icon,
      fixMinHeight,
      alignCenter,
      className,
      hoverDisabled,
    } = this.props;
    return (
      <div
        className={cn(styles.item, className, styles[fixMinHeight], {
          [styles.alignCenter]: alignCenter,
          [styles.hoverDisabled]: hoverDisabled,
        })}
      >
        {Icon && (
          <div className={styles.icon}>
            <Icon />
          </div>
        )}
        <div className={styles.content}>{children}</div>
      </div>
    );
  }
}
